module.exports = __webpack_public_path__ + "static/media/8OLA24.cbcee4a3.jpg";